import Map from './map'
import Marker from './marker'
import Polygon from './polygon'
import Polyline from './polyline'
import Circle from './circle'
import Tooltip from './tooltip'
import Popup from './popup'

export default {
  Map,
  Marker,
  Polygon,
  Polyline,
  Tooltip,
  Popup,
  Circle,
}
